import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3993831471/src/web/components/landing-test/CtaLink.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3993831471/src/web/components/landing-test/landing.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3993831471/src/web/components/landing-test/LoggedInRedirect.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3993831471/src/web/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3993831471/src/web/public/assets/landing/av0.jpg");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3993831471/src/web/public/assets/landing/av1.jpg");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3993831471/src/web/public/assets/landing/av2.jpg");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3993831471/src/web/public/assets/landing/food0.jpg");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3993831471/src/web/public/assets/landing/food1.jpg");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3993831471/src/web/public/assets/landing/food2.jpg");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3993831471/src/web/public/assets/landing/rustic-groceries.webp");
